@if (isEsko$ | async) {
  <a class="esko-wordmark" [ngClass]="class" [href]="'https://esko.ai'" target="_blank">
    <mat-icon [style.color]="color">esko_wordmark</mat-icon>
  </a>
} @else {
  <a class="zeffi-wordmark" [ngClass]="class" href="https://zef.fi" target="_blank">
    <mat-icon [style.color]="color">zeffi_wordmark</mat-icon>
  </a>
}
